export var NavigationType;
(function (NavigationType) {
    NavigationType["SPATIAL"] = "SPATIAL";
    NavigationType["VERTICAL"] = "VERTICAL";
    NavigationType["HORIZONTAL"] = "HORIZONTAL";
    NavigationType["MANUAL"] = "MANUAL";
})(NavigationType || (NavigationType = {}));
